(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ztw-brand-text"] && !Shopify.designMode) return;
  try {
    (() => {
  const excluded = 'script,style,noscript,svg,math,canvas,textarea,input,code,pre,[contenteditable]:not([contenteditable="false"]),[data-zippo-logo],.header__heading,.header__heading-link,.product__sku,.ztw-brand-text';
  const tokens = /(?:https?:\/\/|www\.)[^\s<>"']+|[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}|(?:[\w-]+\.)+[A-Za-z]{2,}(?:\/[^\s<>"']*)?|(?<![A-Za-z0-9_])zippo(?![A-Za-z0-9_])/gi;

  function formatNode(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(excluded)) return;
    const corrected = node.data.replace(/Harley-Davidson[?]/g, 'Harley-Davidson®').replace(/HARLEY-DAVIDSON\?/g, 'HARLEY-DAVIDSON®');
    if (corrected !== node.data) node.data = corrected;
    if (!/zippo/i.test(node.data)) return;
    const matches = Array.from(node.data.matchAll(tokens)).filter(match => /^zippo$/i.test(match[0]));
    if (!matches.length) return;
    if (parent.closest('select,option,optgroup,title')) {
      const formatted = node.data.replace(tokens, value => /^zippo$/i.test(value) ? 'Zippo' : value);
      if (formatted !== node.data) node.data = formatted;
      return;
    }
    const fragment = document.createDocumentFragment();
    let offset = 0;
    for (const match of matches) {
      fragment.append(document.createTextNode(node.data.slice(offset, match.index)));
      const brand = document.createElement('span');
      brand.className = 'ztw-brand-text';
      brand.textContent = 'Zippo';
      fragment.append(brand);
      offset = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(node.data.slice(offset)));
    node.replaceWith(fragment);
  }

  function formatTree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      formatNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(formatNode);
  }

  function start() {
    formatTree(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') formatNode(record.target);
        else record.addedNodes.forEach(formatTree);
      }
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ztw-click-sound"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ztw-click-sound')){
 customElements.define('ztw-click-sound',class extends HTMLElement{
  connectedCallback(){
   if(this.dataset.ready)return;this.dataset.ready='true';
   const button=this.querySelector('button'),audio=this.querySelector('audio'),status=this.querySelector('[role="status"]');
   button.addEventListener('click',async()=>{status.textContent='';try{audio.currentTime=0;await audio.play();}catch{status.textContent=status.dataset.error;}});
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ztw-dealer-localization"] && !Shopify.designMode) return;
  try {
    (() => {
  const source = document.getElementById('ztw-dealer-labels');
  if (!source) return;
  const labels = JSON.parse(source.textContent);
  let pending = false;
  const translate = () => {
    pending = false;
    const form = document.getElementById('bss-b2b-registration-form');
    if (!form) return;
    form.querySelectorAll('h1,h4,label,.bss-message,.bss-b2b-registration-form-message').forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const key = node.textContent.trim();
        if (labels[key] && labels[key] !== key) node.textContent = node.textContent.replace(key, () => labels[key]);
      }
      const title = element.getAttribute('title');
      if (title && labels[title] && title !== labels[title]) element.setAttribute('title', labels[title]);
    });
    const submit = form.querySelector('input[type="submit"]');
    if (submit && submit.value === 'SUBMIT' && labels.SUBMIT !== 'SUBMIT') submit.value = labels.SUBMIT;
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(translate); } };
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, characterData: true });
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ztw-help-layout"] && !Shopify.designMode) return;
  try {
    function initZtwHelp() {
    document.querySelectorAll('[data-ztw-help]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const nav = root.querySelector('.ztw-help-nav');
      if (nav && window.matchMedia('(max-width: 989px)').matches) nav.open = false;
      const headings = [...root.querySelectorAll('.ztw-help-copy h2[id]')];
      const toc = root.querySelector('.ztw-help-toc');
      if (toc && headings.length > 1) {
        headings.forEach(heading => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          item.append(link);
          toc.querySelector('ul').append(item);
        });
        toc.hidden = false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initZtwHelp, { once: true });
  else initZtwHelp();
  document.addEventListener('shopify:section:load', initZtwHelp);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ztw-interface-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  /* This enhancer is cart-only. Avoid installing a page-wide MutationObserver
     on home, collection and product pages where none of these elements exist. */
  if (!document.getElementById('ztw-checkout-messages')) return;

  let pending = false;
  const enhance = () => {
    pending = false;
    enhanceCheckout();
    const select = document.getElementById('waaship-invoice-type-select');
    const template = document.getElementById('ztw-invoice-options-template');
    if (!select || !template || !['e-invoice', 'carrier', 'business-id'].every(value => Array.from(select.options).some(option => option.value === value))) return;
    const wrapper = select.closest('#waaship-invoice-wrapper');
    if (!wrapper) return;
    let choices = wrapper.querySelector('.ztw-invoice-choices');
    if (!choices) {
      choices = template.content.firstElementChild.cloneNode(true);
      select.parentElement.insertBefore(choices, select);
      choices.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        const currentSelect = wrapper.querySelector('#waaship-invoice-type-select');
        if (!currentSelect) return;
        currentSelect.value = event.target.value;
        currentSelect.dispatchEvent(new Event('change', { bubbles: true }));
        schedule();
      });
      select.addEventListener('change', schedule);
      select.hidden = true;
      const oldHeading = wrapper.querySelector('.waaship-collection-collection-label');
      if (oldHeading) oldHeading.hidden = true;
    }
    choices.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === select.value; });
    const labels = document.getElementById('ztw-invoice-field-labels');
    if (labels) {
      [['mobileCarrierInput', 'carrier'], ['businessTitleInput', 'company'], ['businessIdInput', 'tax']].forEach(([id, key]) => {
        const input = wrapper.querySelector('#' + id);
        if (input && input.getAttribute('aria-label') !== labels.dataset[key]) input.setAttribute('aria-label', labels.dataset[key]);
      });
    }
  };
  const invoiceComplete = () => {
    const select = document.getElementById('waaship-invoice-type-select');
    if (!select) return false;
    const ids = select.value === 'carrier' ? ['mobileCarrierInput'] : select.value === 'business-id' ? ['businessTitleInput', 'businessIdInput'] : [];
    return ids.every(id => document.getElementById(id)?.value.trim());
  };
  const selectedLogisticsItem = () => {
    const collection = document.getElementById('waaship-logistics-collection');
    if (!collection) return null;
    const active = collection.querySelector('.waaship-collection-item-wrapper.active, .waaship-collection-item-wrapper .active');
    return active?.closest('.waaship-collection-item-wrapper') || null;
  };
  const checkoutState = () => {
    const button = document.getElementById('checkout');
    if (!document.getElementById('waaship-logistics-collection')) return 'loading';
    if (!invoiceComplete()) return 'invoice';
    const selected = selectedLogisticsItem();
    if (!selected) return 'shipping';
    if (button?.classList.contains('remove_button')) return selected.id?.endsWith('-cvs') ? 'cvs' : 'shipping';
    return 'ready';
  };
  const enhanceCheckout = () => {
    const logistics = document.getElementById('waaship-logistics');
    const action = document.getElementById('ztw-checkout-action');
    if (logistics && action?.contains(logistics)) action.before(logistics);
    const block = document.getElementById('waaship-logistics-wrapper');
    const template = document.getElementById('ztw-shipping-heading-template');
    if (block && template && !block.querySelector('.ztw-shipping-heading')) {
      block.prepend(template.content.firstElementChild.cloneNode(true));
      const oldHeading = block.querySelector(':scope > .waaship-collection-collection-label');
      if (oldHeading) oldHeading.hidden = true;
    }
    const logisticsItems = Array.from(document.querySelectorAll('#waaship-logistics-collection .waaship-collection-item-wrapper'));
    const actualSelected = selectedLogisticsItem();
    if (actualSelected) {
      logisticsItems.forEach(item => {
        const selected = item === actualSelected;
        item.classList.toggle('ztw-selected', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }
    logisticsItems.forEach(item => {
      if (!item.dataset.ztwAccessible) {
        item.dataset.ztwAccessible = 'true';
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); item.click(); }
        });
      }
      if (!item.dataset.ztwSelectionBound) {
        item.dataset.ztwSelectionBound = 'true';
        item.addEventListener('click', () => {
          logisticsItems.forEach(candidate => candidate.classList.toggle('ztw-selected', candidate === item));
          item.setAttribute('aria-selected', 'true');
          requestAnimationFrame(schedule);
          setTimeout(schedule, 120);
          setTimeout(() => {
            const confirmed = selectedLogisticsItem();
            if (!confirmed) item.classList.remove('ztw-selected');
            schedule();
          }, 1500);
        });
      }
    });
    const button = document.getElementById('checkout');
    const messages = document.getElementById('ztw-checkout-messages');
    const status = document.getElementById('ztw-checkout-status');
    if (!button || !messages || !status) return;
    const state = checkoutState();
    const disabled = state === 'ready' ? 'false' : 'true';
    if (button.getAttribute('aria-disabled') !== disabled) button.setAttribute('aria-disabled', disabled);

    /* Waaship briefly removes/rebuilds its logistics collection while syncing.
       Keep that transient state invisible instead of flashing "載入中…" at
       every step. Checkout remains gated until Waaship is actually ready. */
    if (state === 'loading') {
      status.hidden = true;
      return;
    }

    status.hidden = state === 'ready';
    if (!status.classList.contains('ztw-checkout-error') || state === 'ready') {
      if (status.textContent !== messages.dataset[state]) status.textContent = messages.dataset[state];
      if (state === 'ready' && status.classList.contains('ztw-checkout-error')) status.classList.remove('ztw-checkout-error');
    }
  };
  const guardCheckout = event => {
    const state = checkoutState();
    if (state === 'ready') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const status = document.getElementById('ztw-checkout-status');
    const messages = document.getElementById('ztw-checkout-messages');
    const visibleState = state === 'loading' ? (invoiceComplete() ? 'shipping' : 'invoice') : state;
    if (status && messages) { status.hidden = false; status.textContent = messages.dataset[visibleState]; status.classList.add('ztw-checkout-error'); }
    const target = visibleState === 'invoice' ? document.getElementById('waaship-invoice-wrapper') : document.getElementById('waaship-logistics-wrapper');
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  document.addEventListener('click', event => {
    if (event.target.closest('#checkout') && document.getElementById('ztw-checkout-status')) guardCheckout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.id === 'checkout' && document.getElementById('ztw-checkout-status')) guardCheckout(event);
  }, true);
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(enhance); } };
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ztw-kb-article"] && !Shopify.designMode) return;
  try {
    function initZtwHelp() {
    document.querySelectorAll('[data-ztw-help]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const nav = root.querySelector('.ztw-help-nav');
      if (nav && window.matchMedia('(max-width: 989px)').matches) nav.open = false;
      const headings = [...root.querySelectorAll('.ztw-help-copy h2[id]')];
      const toc = root.querySelector('.ztw-help-toc');
      if (toc && headings.length > 1) {
        headings.forEach(heading => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          item.append(link);
          toc.querySelector('ul').append(item);
        });
        toc.hidden = false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initZtwHelp, { once: true });
  else initZtwHelp();
  document.addEventListener('shopify:section:load', initZtwHelp);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ztw-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ztw-product-information')) {
  customElements.define('ztw-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.dataset.enhanced = 'true';
      const source = this.querySelector('[data-source]');
      if (source) {
        let breaks = 0;
        Array.from(source.childNodes).forEach(node => {
          if (node.nodeName === 'BR') { breaks++; if (breaks > 2) node.remove(); }
          else if (node.nodeType !== Node.TEXT_NODE || node.textContent.trim()) breaks = 0;
        });
      }
      if (this.dataset.windproof === 'true') {
        if (!source) return;
        const copy = source.cloneNode(true);
        copy.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
        const text = copy.textContent.replace(/\u00a0/g, ' ');
        const dimension = '(\\d+(?:[.,]\\d+)?)\\s*(mm|cm|毫米|公分|inches|inch|in|["″])';
        const tolerance = '(?:\\s*[（(]\\s*±\\s*\\d+(?:\\.\\d+)?\\s*%\\s*[)）])?';
        const patterns = {
          width: new RegExp('(?:火機寬度|寬度|(?:Lighter\\s+)?Width)\\s*[：:]\\s*' + dimension + tolerance, 'i'),
          height: new RegExp('(?:火機高度|高度|(?:Lighter\\s+)?Height)\\s*[：:]\\s*' + dimension + tolerance, 'i'),
          depth: new RegExp('(?:火機厚度|(?:^|[\\s：:])厚度|(?:Lighter\\s+)?(?:Thickness|Depth))\\s*[：:]\\s*' + dimension + tolerance, 'i'),
          weight: new RegExp('(?:火機重量|重量|(?:Lighter\\s+)?Weight)\\s*[：:]\\s*(\\d+(?:[.,]\\d+)?)\\s*(kg|g|公克|克|oz|ounces)' + tolerance, 'i')
        };
        // Remove only a whole, plain measurement row after all its text is recognized.
        // Leave narrative, warranty, origin, materials, nested HTML and extra specs intact.
        const rows = [[]];
        Array.from(source.childNodes).forEach(node => {
          if (node.nodeName === 'BR') rows.push([]);
          else rows[rows.length - 1].push(node);
        });
        let removed = false;
        const kept = rows.filter(row => {
          if (row.some(node => node.nodeType === 1)) return true;
          let rest = row.map(node => node.textContent).join('').replace(/\u00a0/g, ' ').trim();
          let matches = 0;
          Object.values(patterns).forEach(pattern => { if (pattern.test(rest)) { rest = rest.replace(pattern, ''); matches++; } });
          rest = rest.replace(/^(規格|Specifications?|Product Specs?)\s*[：:]\s*/i, '').trim();
          if (matches && !rest) { removed = true; return false; }
          return true;
        });
        if (removed) {
          source.replaceChildren();
          kept.forEach((row, index) => { if (index) source.append(document.createElement('br')); row.forEach(node => source.append(node)); });
        }
        return;
      }
      if (!source || !Array.from(source.childNodes).some(node => node.nodeName === 'BR')) return;
      if (Array.from(source.children).some(node => node.nodeName !== 'BR' && node.querySelector('br, p, div, table, ul, ol'))) return;
      const rows = [[]];
      Array.from(source.childNodes).forEach(node => {
        if (node.nodeName === 'BR') rows.push([]);
        else rows[rows.length - 1].push(node.cloneNode(true));
      });
      const text = row => row.map(node => node.textContent).join('').replace(/\u00a0/g, ' ').trim();
      const specIndex = rows.findIndex(row => /^(品名\s*[：:]|商品名稱\s*[：:]|Product(?: Name)?\s*:)/i.test(text(row)));
      if (specIndex < 0) return;
      const careIndex = this.dataset.windproof === 'true' ? rows.findIndex((row, i) => i > specIndex && /^[•‧·\-]?\s*(正品\s*Zippo|Genuine Zippo)/i.test(text(row))) : -1;
      const appendRows = (target, items) => {
        const meaningful = items.slice();
        while (meaningful.length && !text(meaningful[0]) && !meaningful[0].some(n => n.nodeType === 1)) meaningful.shift();
        while (meaningful.length && !text(meaningful[meaningful.length - 1]) && !meaningful[meaningful.length - 1].some(n => n.nodeType === 1)) meaningful.pop();
        meaningful.forEach((row, i) => { if (i) target.append(document.createElement('br')); row.forEach(node => target.append(node)); });
      };
      const descriptionRows = rows.slice(0, specIndex);
      source.replaceChildren();
      appendRows(source, descriptionRows);
      if (!source.textContent.trim() && !source.querySelector('img,video,iframe') && !this.querySelector('.ztw-editorial-description')?.textContent.trim()) this.querySelector('[data-description]').hidden = true;
      const specs = this.querySelector('[data-specification-content]');
      appendRows(specs, rows.slice(specIndex, careIndex < 0 ? rows.length : careIndex));
      this.querySelector('[data-specifications]').hidden = false;
      if (this.querySelector('[data-description]').hidden) this.querySelector('[data-specifications]').open = true;
      if (careIndex >= 0) {
        appendRows(this.querySelector('[data-care-content]'), rows.slice(careIndex));
        this.querySelector('[data-care]').hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
